import { ISetUserResponse } from "@fkhplus/common/src/modules/user/interfaces";
import { IFluxStandardAction } from "@fkhplus/common/src/modules/interfaces";

const actionTypePrefix = 'User/';

export const UserActionTypes = {
    IS_LOGGED_IN : `${actionTypePrefix}IS_LOGGED_IN`,
};

export type UserPayload = boolean | string;

export const setUserLogin = (payload : boolean) : IFluxStandardAction<boolean> => {
    return {
    type: UserActionTypes.IS_LOGGED_IN,
    payload
    };
};
